var React = require('react');

function CloseMobileMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-.52893 -.52893)","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"transform":"translate(-684,-44)","stroke":"#000E35","strokeWidth":"4.8"},React.createElement("g",{"transform":"translate(686,46)"},[React.createElement("path",{"transform":"rotate(45,8,8)","d":"m-2 8h20","key":0}),React.createElement("path",{"transform":"matrix(-.70711 .70711 .70711 .70711 8 -3.3137)","d":"m-2 8h20","key":1})]))));
}

CloseMobileMenu.defaultProps = {"width":"18.942","height":"18.942","version":"1.1","viewBox":"0 0 18.942 18.942"};

module.exports = CloseMobileMenu;

CloseMobileMenu.default = CloseMobileMenu;
